import dynamic from "next/dynamic";
import { useState } from "react";
import RegistrationLayout from "@Components/RagistrationLayout";
import { useRouter } from "next/router";
import Interceptor from "hoc/Interceptor";
import VerifyOtp from "./verifyOtp";

const RegistrationForm = dynamic(() => import("./RegistrationForm"), {
  ssr: false,
});

const Registration = () => {
  const [index, setIndex] = useState(0);
  const [phoneNo, setPhoneNo] = useState("");
  const router = useRouter();

  const handleSaveIndexAndPhoneNo = (index: any, phoneNo: any) => {
    console.log(index, "index in registration page", phoneNo);
    setIndex(index);
    setPhoneNo(phoneNo);
  };
  console.log(index, "index in registration page");

  return (
    <>
      {index === 0 ? (
        <RegistrationLayout
          title="Create Account"
          dividerText="Already have an account?"
          buttonText="Login to your Econut account"
          onButtonClicked={() => router.push("/login")}
        >
          <RegistrationForm
            handleSaveIndexAndPhoneNo={handleSaveIndexAndPhoneNo}
          />
        </RegistrationLayout>
      ) : (
        typeof window !== "undefined" && <VerifyOtp PhoneNo={phoneNo} />
      )}
    </>
  );
};

export default Interceptor(Registration);
